module.exports = __webpack_public_path__ + "img/audio.326a2956.svg";